module.exports = __webpack_public_path__ + "static/media/dolphin.42726bbf.jpg";